<template>
  <div>
    <v-alert v-if="globalServerErrors !== null" dense outlined type="error">
      <p class="mb-0" v-for="globalErr in globalServerErrors" :key="globalErr">
        {{ globalErr[0] }}
      </p>
    </v-alert>
    <v-col cols="12" md="6" class="mx-auto">
      <v-text-field
        outlined
        :loading="loadingRelatedData"
        :disabled="loadingRelatedData"
        :append-icon="filterInputs.search ? 'mdi-close' : ''"
        v-model="filterInputs.search"
        :placeholder="$t('button.search')"
        prepend-inner-icon="mdi-magnify"
        :hide-details="!!hint || hideDetails"
      ></v-text-field>

      <small v-if="hint" class="mb-3 mx-2 mt-1 d-block">
        Hint: {{ hint }}
      </small>
    </v-col>

    <section class="filter-area">
      <v-container class="py-0">
        <v-row>
          <v-col cols="12" sm="10" class="mx-auto py-0">
            <v-row justify="space-between">
              <v-col cols="12" sm="6" class="success-select pb-0">
                <v-autocomplete
                  class="pt-0"
                  :items="filterArray"
                  item-text="name"
                  item-value="id"
                  v-model="filterInputs.category"
                  :label="$t('label.category')"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="6" class="error-select pb-0">
                <v-autocomplete
                  class="pt-0"
                  color="#B71C1C"
                  :items="filterArray"
                  item-text="name"
                  item-value="id"
                  :label="$t('label.sub_categories')"
                  v-model="filterInputs.sub_category"
                ></v-autocomplete>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </section>
    <v-col cols="12" md="6" class="mx-auto mt-5">
      <v-btn
        v-if="!downloading"
        class="text-capitalize"
        large
        rounded
        color="error"
        outlined
        @click="handleSave()"
        width="100%"
        ><span>Export</span>
      </v-btn>
      <v-btn
        class="text-capitalize"
        large
        rounded
        width="100%"
        color="success"
        outlined
        v-else
        :href="url"
        @click="download"
        >Download</v-btn
      >
    </v-col>
  </div>
</template>

<script>
import { IndexData, ExportData } from "@/helpers/apiMethods";

export default {
  name: "OnHandReports",
  components: {
    InputFilter: () => import("@/views/accounts/components/InputFilter"),
  },

  async mounted() {
    await this.indexSCMOnHandsRelatedData();

    Object.keys(this.filterInputs).forEach((key) => {
      if (key === "without_zero") {
        this.filterInputs[key] =
          !this.$route.query[key] && this.$route.query[key] === "no"
            ? "no"
            : "yes";
      } else {
        this.filterInputs[key] = this.$route.query[key] || "";
      }
    });
    this.mappingQueryFiltersInputs = false;
  },
  data() {
    return {
      downloading: false,
      subInventories: [],
      locators: [],
      filterArray: [{ name: "defaut", id: 1 }],

      filterInputs: {
        category: "",
        sub_category: "",
        search: "",
      },
      url: {},
      loadingLocators: false,
      loadingRelatedData: false,
      mappingQueryFiltersInputs: true,
      hint: this.$t("search_hint"),
      globalServerErrors: null,
    };
  },
  computed: {
    selectedSCMInventoryInfo() {
      const selectedSCMInventory = this.filterInputs.inventory
        ? this.subInventories.find(
            (inventory) =>
              inventory.id.toString() === this.filterInputs.inventory.toString()
          )
        : {};
      return selectedSCMInventory || {};
    },
  },
  methods: {
    handleSave() {
      const query = {};
      for (const key in this.filterInputs) {
        if (this.filterInputs[key] !== "") {
          query[key] = this.filterInputs[key];
        }
      }
      IndexData({
        reqName: `reports/item-control`,
        query,
      })
        .then((res) => {
          this.url = res.data.url;

          this.downloading = true;
        })
        .catch((err) => {
          this.globalServerErrors = err.response.data.errors;
          this.scrollTop();
        })
        .finally(() => {
          this.loadingRequest = false;
        });
    },
    download() {
      this.downloading = false;
      this.form = {};
    },
    onSubInventoriesChange() {
      let selectedInventroy = { for_camps: "", for_employees: "" };
      selectedInventroy = this.subInventories.find(
        (sub) => sub.id === this.filterInputs.inventory
      );
      console.log(selectedInventroy);

      selectedInventroy.for_camps === 1
        ? (this.filterInputs.locator_type = "camps")
        : (this.filterInputs.locator_type = "employees");

      if (
        selectedInventroy.for_camps === 0 &&
        selectedInventroy.for_employees === 0
      ) {
        this.filterInputs.locator_type = "none";
        this.locators = [];
      }
      if (this.filterInputs.locator_type !== "none") {
        this.fetchLocators();
      }
    },
    async indexSCMOnHandsRelatedData() {
      try {
        this.loadingRelatedData = true;
        const subInventoriesRes = await IndexData({
          reqName: "scm/inventories",
        });

        this.subInventories =
          subInventoriesRes && subInventoriesRes.data
            ? subInventoriesRes.data.data.map((subInventor) => ({
                ...subInventor,
                id: subInventor.id.toString(),
              }))
            : [];
      } catch (err) {
        console.log(err);
      } finally {
        this.loadingRelatedData = false;
      }
    },
    async fetchLocators() {
      if (this.filterInputs.locator_type !== "none") {
        try {
          const reqName =
            this.filterInputs.locator_type === "camps"
              ? "scm/camps"
              : "scm/employees";

          this.loadingLocators = true;
          const res = await IndexData({
            reqName,
            query: { pagination: "all" },
          });
          this.locators = res.data.data.map((locator) => ({
            ...locator,
            id: locator.id.toString(),
          }));
        } catch (err) {
          console.log();
        } finally {
          this.loadingLocators = false;
        }
      }
    },
  },
};
</script>
